import { useEffect, useState } from "react";
import { Icon } from "@/components/Icon/Icon";

type LockPulseProps = {
  reason: string;
  onDone: () => void;
};

export function LockPulse({ reason, onDone }: LockPulseProps) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const enter = setTimeout(() => setLeaving(true), 1800);
    const exit = setTimeout(onDone, 1800 + 220);
    return () => {
      clearTimeout(enter);
      clearTimeout(exit);
    };
  }, [onDone]);

  return (
    <div className={leaving ? "lock-pulse leaving" : "lock-pulse entering"}>
      <Icon name="lock" size={11} />
      <span style={{ flex: 1 }}>{reason}</span>
    </div>
  );
}
